// extracted by mini-css-extract-plugin
module.exports = {"time-slot-text":"Preview_time-slot-text__x2g_M","upcoming-ents-text":"Preview_upcoming-ents-text__Jm_Jn"};